import { ratingOptions } from './RatingSelector.jsx';

export default function FilterBar({ value, onChange, counts = {}, includeUnrated = true }) {
  const options = [
    { value: 'all', label: 'Alle', count: counts.all },
    ...(includeUnrated ? [{ value: 'unrated', label: 'Ohne', count: counts.unrated }] : []),
    ...ratingOptions.map((option) => ({
      value: option.value,
      label: option.label,
      count: counts[option.value]
    }))
  ];

  return (
    <div className="proof-filter" role="tablist" aria-label="Bildstatus filtern">
      {options.map((option) => (
        <button
          type="button"
          className={value === option.value ? 'is-active' : ''}
          onClick={() => onChange(option.value)}
          key={option.value}
        >
          {option.label}
          <span>{option.count || 0}</span>
        </button>
      ))}
    </div>
  );
}
